// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2Ryeh","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__QsXcg"};